import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'service-item',
  templateUrl: './service-item.component.html',
  styleUrls: ['./service-item.component.scss'],
})
export class ServiceItemComponent {
  dummyImg = "assets/dummy.png";
  
  @Input() filteredServiceLists: any = [];
  @Input() type?: any = "salon";
  @Output() serviceSelected = new EventEmitter<string>(); // Emits the sid


  constructor() {
    
  }


  onServiceClick(sid: string): void {
    // this.selectedService = sid; // Update internal state to reflect selection
    this.serviceSelected.emit(sid); // Emit the selected service ID
    // console.log('Service with ID:', sid, 'was selected.');
  }

}